import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
var RowItem = /*#__PURE__*/function (_Component) {
  function RowItem() {
    _classCallCheck(this, RowItem);
    return _callSuper(this, RowItem, arguments);
  }
  _inherits(RowItem, _Component);
  return _createClass(RowItem, [{
    key: "render",
    value: function render() {
      var props = _objectSpread({}, this.props);
      delete props.children;
      delete props.target;
      if (this.props.target != null) {
        return /*#__PURE__*/React.createElement(Link, _extends({
          className: "row",
          to: this.props.target
        }, props), this.props.children);
      }
      return /*#__PURE__*/React.createElement("div", _extends({
        className: "row"
      }, this.props), this.props.children);
    }
  }]);
}(Component);
export var RowCell = function RowCell(props) {
  var className = 'cell';
  if (props.grow) {
    className += ' grow';
  }
  if (props.shrink) {
    className += ' shrink';
  }
  var elementProps = _objectSpread({}, props);
  delete elementProps.grow;
  delete elementProps.shrink;
  delete elementProps.children;
  delete elementProps.title;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    title: props.title
  }, elementProps), props.children);
};
export default RowItem;